export var SaveType;
(function (SaveType) {
    SaveType["Save"] = "SAVE";
    SaveType["SaveAs"] = "SAVE_AS";
    SaveType["SaveByE2E"] = "SAVE_BY_E2E";
    SaveType["AutoSave"] = "AUTO_SAVE";
    SaveType["Rename"] = "RENAME";
})(SaveType || (SaveType = {}));
export var SaveActionType;
(function (SaveActionType) {
    SaveActionType["ConvertOnlineSave"] = "convertOnlineSave";
    SaveActionType["LocalSave"] = "localSave";
    SaveActionType["Save4Close"] = "save4Close";
})(SaveActionType || (SaveActionType = {}));
export var EditCommonEvent;
(function (EditCommonEvent) {
    // web -> 桌面端
    EditCommonEvent["CloseTab"] = "close-tab";
    /**
     * 有改动则传 true，撤销全部改动传 false
     */
    EditCommonEvent["ContentModified"] = "content-modified";
    /**
     * 更新标题，不带后缀
     */
    EditCommonEvent["UpdateTitle"] = "update-title";
    EditCommonEvent["TimeTrack"] = "time-track";
    // 桌面端 -> web
    EditCommonEvent["Save"] = "save";
})(EditCommonEvent || (EditCommonEvent = {}));
export var VersionType;
(function (VersionType) {
    VersionType["Current"] = "current";
    VersionType["AutoSave"] = "auto-save";
    VersionType["Origin"] = "origin";
})(VersionType || (VersionType = {}));
export const SHOW_VERSION_DIALOG_EVENT = 'show-version-dialog';
//# sourceMappingURL=mega-common.protocol.js.map